import { CompetitorComparisonLayout } from "@/components/marketing/CompetitorComparisonLayout";
import { COMPETITORS } from "@/lib/marketing-competitor-matrix";

export default function VsAutomationToolsPage() {
  return <CompetitorComparisonLayout competitor={COMPETITORS["zapier-make"]} />;
}
